import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { FarmacoPageRoutingModule } from './farmaco-routing.module';
import { FarmacoPage } from './farmaco.page';
import { ComponentsModule } from 'src/app/components/components.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    FarmacoPageRoutingModule,
    ComponentsModule,
  ],
  declarations: [FarmacoPage],
})
export class FarmacoPageModule {}
